import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { toast } from 'sonner';
import { useLocation } from "react-router-dom"; // Import for detecting route changes

// Billing cycles data from your original component
const billingCycles = [
  // Basic billing cycles
  { name: "A / 1 (1-31)", start: 1, end: 31 },
  { name: "B / 8 (8-7)", start: 8, end: 7 },
  { name: "C / 15 (15-14)", start: 15, end: 14 },
  { name: "D / 22 (22-21)", start: 22, end: 21 },
  { name: "GECC (6-5)", start: 6, end: 5 },
  { name: "Hagonoy (7-6)", start: 7, end: 6 },
  { name: "NCR (1-31)", start: 1, end: 31 },
  { name: "Pampanga E15 (10-9)", start: 10, end: 9 },

  // Bataan and surroundings
  { name: "Balanga (1-31)", start: 1, end: 31 },
  { name: "Mariveles/CORPS (5-4)", start: 5, end: 4 },
  { name: "Orani (5-4)", start: 5, end: 4 },
  { name: "Dinalupihan (5-4)", start: 5, end: 4 },
  { name: "Morong (5-4)", start: 5, end: 4 },
  { name: "Hermosa (10-9)", start: 10, end: 9 },
  { name: "Subic (5-4)", start: 5, end: 4 },

  // GECC Group
  { name: "Gemsat (6-5)", start: 6, end: 5 },
  { name: "Good Shepherd (6-5)", start: 6, end: 5 },
  { name: "Northstar (6-5)", start: 6, end: 5 },
  { name: "Northwire (6-5)", start: 6, end: 5 },
  { name: "Rainbow (6-5)", start: 6, end: 5 },
  { name: "Villarama (6-5)", start: 6, end: 5 },

  // Bulacan Area
  { name: "MasterCable/Bulakan (6-5)", start: 6, end: 5 },
  { name: "Norzagaray (6-5)", start: 6, end: 5 },
  { name: "Calumpit (6-5)", start: 6, end: 5 },
  { name: "Alphavision Bustos (6-5)", start: 6, end: 5 },

  // Corporate Accounts
  { name: "ISG-Corporate (1-31)", start: 1, end: 31 },
  { name: "BSG-Corporate (1-31)", start: 1, end: 31 },
  { name: "BSG-Residential (1-31)", start: 1, end: 31 },
  { name: "ACCTN-Corporate (1-31)", start: 1, end: 31 },
  { name: "ACCTN (10-9)", start: 10, end: 9 },
  { name: "Converge/Comclark (10-9)", start: 10, end: 9 },
  { name: "CLCTN (10-9)", start: 10, end: 9 },
  { name: "Satellite Cable (1-31)", start: 1, end: 31 },

  // Pampanga Region
  { name: "Candaba (10-9)", start: 10, end: 9 },
  { name: "San Luis (10-9)", start: 10, end: 9 },
  { name: "STA. ANA (10-9)", start: 10, end: 9 },
  { name: "Floridablanca (5-4)", start: 5, end: 4 },
  { name: "Florida Fiber (5-4)", start: 5, end: 4 },
  { name: "Apalit (8-7)", start: 8, end: 7 },
  { name: "ACTS (8-7)", start: 8, end: 7 },
  { name: "DATELCOM (8-7)", start: 8, end: 7 },
  { name: "Arayat (8-7)", start: 8, end: 7 },
  { name: "Pandacaqui (8-7)", start: 8, end: 7 },
  { name: "San Fernando (10-9)", start: 10, end: 9 },
  { name: "Mexico (8-7)", start: 8, end: 7 },
  { name: "Sto. Tomas (7-6)", start: 7, end: 6 },
  { name: "Bamban (10-9)", start: 10, end: 9 },
  { name: "Concepcion (10-9)", start: 10, end: 9 },
  { name: "Capas (10-9)", start: 10, end: 9 },
  { name: "I / 15 (10-9)", start: 10, end: 9 },
  { name: "Pampanga E10 (1-31)", start: 1, end: 31 },
  { name: "G / 11 (6-5)", start: 6, end: 5 },
  { name: "Pampanga 10 - 9 (10-9)", start: 10, end: 9 },

  // Tarlac and Northern Luzon
  { name: "Hitech/CORPS (8-7)", start: 8, end: 7 },
  { name: "Primecast/CORPS (8-7)", start: 8, end: 7 },
  { name: "San Clemente (8-7)", start: 8, end: 7 },
  { name: "Gerona (8-7)", start: 8, end: 7 },
  { name: "Victoria (8-7)", start: 8, end: 7 },
  { name: "Paniqui (8-7)", start: 8, end: 7 },
  { name: "La Paz (7-6)", start: 7, end: 6 },
  { name: "Zaragosa (8-7)", start: 8, end: 7 },
  { name: "Umili (8-7)", start: 8, end: 7 },

  // North Luzon
  { name: "Baguio (7-6)", start: 7, end: 6 },
  { name: "Isabela (7-6)", start: 7, end: 6 },
  { name: "Nueva Vizcaya (7-6)", start: 7, end: 6 },
  { name: "Cagayan (7-6)", start: 7, end: 6 },
  { name: "La Trinidad (7-6)", start: 7, end: 6 },
  { name: "Dagupan (7-6)", start: 7, end: 6 },
  { name: "Urdaneta (7-6)", start: 7, end: 6 },
  { name: "Agoo (8-7)", start: 8, end: 7 },
  { name: "Ilocos Sur (8-7)", start: 8, end: 7 },
  { name: "Interlink Baler (8-7)", start: 8, end: 7 },
  { name: "North Central Luzon (10-9)", start: 10, end: 9 },
  { name: "MSP - Bulacan & Bataan (11-10)", start: 11, end: 10 },

  // CALABARZON and Southern Luzon
  { name: "Talisay (1-31)", start: 1, end: 31 },
  { name: "Lipa (1-31)", start: 1, end: 31 },
  { name: "Caceres - Naga (1-31)", start: 1, end: 31 },
  { name: "Magayon (1-31)", start: 1, end: 31 },
  { name: "Mountain Top - Tagaytay (1-31)", start: 1, end: 31 },
  { name: "Trece Marteres - Cavite (1-31)", start: 1, end: 31 },
  { name: "Telmarc - Alaminos (1-31)", start: 1, end: 31 },
  { name: "San Pablo (1-31)", start: 1, end: 31 },
  { name: "Laguna (1-31)", start: 1, end: 31 },
  { name: "Laguna Convera (1-31)", start: 1, end: 31 },
  { name: "Lucena (1-31)", start: 1, end: 31 },
  { name: "Quezon Convera (1-31)", start: 1, end: 31 },
  { name: "Quezon Inet (1-31)", start: 1, end: 31 },
  { name: "Alabang (1-31)", start: 1, end: 31 },
  { name: "Seven E (3-2)", start: 3, end: 2 },
  { name: "Daet, Camarines Norte (5-4)", start: 5, end: 4 },
  { name: "Lucban (5-4)", start: 5, end: 4 },
  { name: "Balayan (6-5)", start: 6, end: 5 },
  { name: "Calatagan (6-5)", start: 6, end: 5 },
  { name: "Lopez (6-5)", start: 6, end: 5 },
  { name: "Atimonan (6-5)", start: 6, end: 5 },
  { name: "San Mateo (6-5)", start: 6, end: 5 },

  // Visayas and Mindanao
  { name: "Cebu (8-7)", start: 8, end: 7 },
  { name: "Davao (8-7)", start: 8, end: 7 }
];

const slowConnectionRate = 0.3;

const RebateCalculator = () => {
  // Animation state
  const [isLoaded, setIsLoaded] = useState(false);

  // Get current location to detect route changes
  const location = useLocation();

  // Reset and replay animations on component mount and when route changes
  useEffect(() => {
    // Reset animation state first
    setIsLoaded(false);

    // Small delay to ensure reset takes effect before starting animations
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 50);

    return () => clearTimeout(timer);
  }, [location.pathname]); // Re-run effect when the path changes

  // State for managing phases
  const [currentPhase, setCurrentPhase] = useState(1);
  // Add this near your other useState declarations
  const [formErrors, setFormErrors] = useState({});
  // Months state
  const [months, setMonths] = useState([
    {
      id: uuidv4(),
      selectedCycle: billingCycles[0],
      planMSF: "1899",
      startDate: "",
      endDate: "",
      daysReported: 0,
      noConnectionRebate: 0,
      slowConnectionRebate: 0,
      cycleDays: 0,
      formulaNoConnection: "",
      formulaSlowConnection: "",
    },
  ]);

  // Customer info state
  const [customerInfo, setCustomerInfo] = useState({
    accountName: "",
    accountNumber: "",
    email: "",
    contactNumber: "",
    ticketNumber: "",
    restorationDate: "",
    rebateReason: "",
    notes: "",
    requestDetails: "",
    rfo: "",
    resolution: "",
    expectation: ""
  });

  const getErrorMessage = (fieldName) => {
    return formErrors[fieldName] ? (
      <p className="text-red-500 text-xs mt-1">{formErrors[fieldName]}</p>
    ) : null;
  };

  // Modal state
  const [showModal, setShowModal] = useState(false);

  // Calculate values function - same logic as your original
  const calculateValues = (month) => {
    if (!month.startDate || !month.endDate) return month;

    const start = dayjs(month.startDate);
    const end = dayjs(month.endDate);
    const cycle = month.selectedCycle;

    const daysInCurrentMonth = dayjs(start).daysInMonth();
    const daysInPrevMonth = dayjs(start.subtract(1, "month")).daysInMonth();
    let cycleDays;

    // Determine cycle days based on start date logic
    if (start.date() < cycle.start) {
      cycleDays = daysInPrevMonth; // Use previous month's total days
    } else {
      cycleDays = daysInCurrentMonth; // Use current month's total days
    }
    month.cycleDays = cycleDays;

    // Ensure proper date range calculations
    const adjustedEndDate = end; // no subtraction
    const diffDays = adjustedEndDate.diff(start, "day") + 1;
    month.daysReported = diffDays;

    // Prevent division by zero
    const validCycleDays = month.cycleDays || 1;

    month.noConnectionRebate = parseFloat(
      ((month.planMSF / validCycleDays) * month.daysReported).toFixed(2)
    );
    month.slowConnectionRebate = parseFloat(
      ((month.planMSF * slowConnectionRate / validCycleDays) * month.daysReported).toFixed(2)
    );

    // Format formula for display
    const formattedStartDate = dayjs(month.startDate).format("MMM D");
    const formattedEndDate = dayjs(month.endDate).format("MMM D, YYYY");
    month.formulaNoConnection = `${formattedStartDate} - ${formattedEndDate}: (${month.planMSF} / ${validCycleDays}) * ${month.daysReported}`;
    month.formulaSlowConnection = `${formattedStartDate} - ${formattedEndDate}: (${month.planMSF} * 0.3 / ${validCycleDays}) * ${month.daysReported}`;

    return month;
  };

  // Update month function
  // Modify the updateMonth function to handle the first month specially
  const updateMonth = (id, field, value) => {
    // Update the specific month
    const updatedMonths = months.map((month) => {
      if (month.id === id) {
        // Create updated month with the new field value
        let updatedMonth = { ...month, [field]: value };

        // Only calculate values if both dates are available
        if (updatedMonth.startDate && updatedMonth.endDate) {
          updatedMonth = calculateValues(updatedMonth);
        }

        return updatedMonth;
      }
      return month;
    });

    setMonths(updatedMonths);
  };
  // When rendering the months table, include the first month if it has data
  const renderMonthsTable = () => {
    // Always include all months in the display, including the first one being edited
    return (
      <div className="p-3">
        {months.map((month, index) => (
          <div
            key={month.id}
            className={`py-2 grid grid-cols-4 text-sm transition-all duration-300 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ transitionDelay: `${100 + (index * 50)}ms` }}
          >
            <div>{month.selectedCycle.name}</div>
            <div>{month.startDate ? dayjs(month.startDate).format('MMM D, YYYY') : 'Not set'}</div>
            <div>{month.endDate ? dayjs(month.endDate).format('MMM D, YYYY') : 'Not set'}</div>
            <div className="flex justify-between items-center">
              <span>{month.planMSF}</span>
              <div className="flex space-x-1">
                {months.length > 1 && (
                  <button
                    onClick={() => deleteMonth(month.id)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                )}
                <button
                  onClick={() => startEditing(month)}
                  className="text-gray-500 hover:text-gray-700"
                  title="Edit"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };
  const [isFormValid, setIsFormValid] = useState(false);
  // Update the validation logic to set overall form validity
  const validateForm = () => {
    const errors = {};
    let isValid = true;

    // Check all months for validity
    months.forEach((month, index) => {
      if (!month.selectedCycle) {
        errors[`month_${index}_cycle`] = 'Billing cycle is required';
        isValid = false;
      }

      if (!month.startDate) {
        errors[`month_${index}_startDate`] = 'Start date is required';
        isValid = false;
      }

      if (!month.endDate) {
        errors[`month_${index}_endDate`] = 'End date is required';
        isValid = false;
      }

      if (month.startDate && month.endDate &&
        new Date(month.endDate) < new Date(month.startDate)) {
        errors[`month_${index}_endDate`] = 'End date must be after start date';
        isValid = false;
      }

      if (!month.planMSF) {
        errors[`month_${index}_planMSF`] = 'Plan MSF is required';
        isValid = false;
      }
    });

    setFormErrors(errors);
    setIsFormValid(isValid);
    return isValid;
  };

  // Call validateForm whenever months data changes
  useEffect(() => {
    validateForm();
  }, [months]);

  // Add month function with validation
  // Modify the addMonth function to validate properly before adding
  const addMonth = () => {
    // Validate the form inputs
    const errors = {};
    let isValid = true;

    if (!months[0].selectedCycle) {
      errors['month_0_cycle'] = 'Billing cycle is required';
      isValid = false;
    }

    if (!months[0].startDate) {
      errors['month_0_startDate'] = 'Start date is required';
      isValid = false;
    }

    if (!months[0].endDate) {
      errors['month_0_endDate'] = 'End date is required';
      isValid = false;
    }

    // Always check date relationship, regardless of the number of entries
    if (months[0].startDate && months[0].endDate &&
      new Date(months[0].endDate) < new Date(months[0].startDate)) {
      errors['month_0_endDate'] = 'End date must be after start date';
      isValid = false;
    }

    if (!months[0].planMSF) {
      errors['month_0_planMSF'] = 'Plan MSF is required';
      isValid = false;
    }

    // If validation fails, update errors and return
    if (!isValid) {
      setFormErrors(errors);
      return;
    }

    // Calculate values for the current month if needed
    let currentMonth = { ...months[0] };
    if (currentMonth.startDate && currentMonth.endDate) {
      currentMonth = calculateValues(currentMonth);
    }

    // Create a new blank month for the next entry
    const newBlankMonth = {
      id: uuidv4(),
      selectedCycle: billingCycles[0],
      planMSF: currentMonth.planMSF || "1899", // Keep the same MSF for convenience
      startDate: "",
      endDate: "",
      daysReported: 0,
      noConnectionRebate: 0,
      slowConnectionRebate: 0,
      cycleDays: 0,
      formulaNoConnection: "",
      formulaSlowConnection: "",
    };

    // Replace the current months array with new array containing:
    // 1. The new blank month for the form
    // 2. The current month that was just completed
    // 3. All other existing months
    setMonths([newBlankMonth, currentMonth, ...months.slice(1)]);

    // Clear any validation errors
    setFormErrors({});
  };
  // Delete a specific month entry
  const deleteMonth = (id) => {
    if (months.length > 1) {
      setMonths(months.filter(month => month.id !== id));
    }
  };

  // Clear months function
  const clearMonths = () => {
    setMonths([
      {
        id: uuidv4(),
        selectedCycle: billingCycles[0],
        planMSF: "1899",
        startDate: "",
        endDate: "",
        daysReported: 0,
        noConnectionRebate: 0,
        slowConnectionRebate: 0,
        cycleDays: 0,
        formulaNoConnection: "",
        formulaSlowConnection: "",
      },
    ]);
  };

  // Handle customer info changes
  const handleCustomerChange = (e) => {
    setCustomerInfo({ ...customerInfo, [e.target.name]: e.target.value });
  };

  // Get date range function - same as your original
  const getDateRange = () => {
    if (!months || months.length === 0) {
      return { firstStartDate: "", lastEndDate: "" };
    }

    // Filter out months without valid dates
    const validMonths = months.filter(month => month.startDate && month.endDate);

    if (validMonths.length === 0) {
      return { firstStartDate: "", lastEndDate: "" };
    }

    // Find earliest start date
    let earliestDate = new Date(validMonths[0].startDate);
    let latestDate = new Date(validMonths[0].endDate);

    // Loop through all months to find earliest start and latest end
    validMonths.forEach(month => {
      const startDate = new Date(month.startDate);
      const endDate = new Date(month.endDate);

      if (startDate < earliestDate) {
        earliestDate = startDate;
      }

      if (endDate > latestDate) {
        latestDate = endDate;
      }
    });

    // Return dates in the format your form expects
    return {
      firstStartDate: earliestDate.toISOString().split('T')[0],
      lastEndDate: latestDate.toISOString().split('T')[0]
    };
  };

  // Recalculate all months
  const recalculateAllMonths = () => {
    const updatedMonths = months.map(month => {
      if (month.startDate && month.endDate) {
        return calculateValues({ ...month });
      }
      return month;
    });

    setMonths(updatedMonths);
  };

  // Handle moving to next phase
  const handleNextPhase = () => {
    recalculateAllMonths();
    setCurrentPhase(2);

    // Reset animations for phase 2
    setIsLoaded(false);
    setTimeout(() => {
      setIsLoaded(true);
    }, 50);
  };

  // Handle going back to previous phase
  const handlePreviousPhase = () => {
    setCurrentPhase(1);

    // Reset animations for phase 1
    setIsLoaded(false);
    setTimeout(() => {
      setIsLoaded(true);
    }, 50);
  };

  // Handle form submission (open modal)
  const handleSubmit = () => {
    setShowModal(true);
  };

  // Handle submit to MongoDB - same as your original
  const handleSubmitToMongoDB = async () => {
    console.log("Submitting rebate to API...");

    // Get the first start date and last end date
    const { firstStartDate, lastEndDate } = getDateRange();

    // Create the payload that will be sent to both endpoints
    const userData = JSON.parse(localStorage.getItem('user') || '{}');

    const payload = {
      customerInfo: {
        ...customerInfo,
        // Include all the CARE format fields
        ticketNumber: customerInfo.ticketNumber,
        restorationDate: customerInfo.restorationDate,
        rebateReason: customerInfo.rebateReason,
        requestDetails: customerInfo.requestDetails,
        rfo: customerInfo.rfo,
        resolution: customerInfo.resolution,
        expectation: customerInfo.expectation,
        notes: customerInfo.notes,
        // Add the issue start and end dates
        issueStartDate: firstStartDate,
        issueEndDate: lastEndDate
      },
      rebateSummary: months.map(month => ({
        billingCycle: month.selectedCycle.name,
        startDate: month.startDate,
        endDate: month.endDate,
        planMSF: month.planMSF,
        cycleDays: month.cycleDays,
        daysReported: month.daysReported,
        noConnectionRebate: month.noConnectionRebate,
        slowConnectionRebate: month.slowConnectionRebate,
        formulaNoConnection: month.formulaNoConnection,
        formulaSlowConnection: month.formulaSlowConnection,
      })),
      // Calculate total rebate amount based on the rebate reason
      totalRebateAmount: customerInfo.rebateReason === "NO INTERNET CONNECTION"
        ? months.reduce((total, m) => total + (m.noConnectionRebate || 0), 0)
        : months.reduce((total, m) => total + (m.slowConnectionRebate || 0), 0),
      // Add user data
      submittedBy: userData
    };

    try {
      // Send to your MongoDB API
      const mongoResponse = await fetch("http://localhost:5000/api/rebate/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      console.log("MongoDB Response received:", mongoResponse);

      // Send to Azure Logic App webhook
      const webhookUrl = "https://prod-34.southeastasia.logic.azure.com:443/workflows/cb2d7a18224a45f996affe10367dc1a9/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=fSo-CijsVhNjyeCrcSzbzM-565exsV0BCKlCxX5vHQ8";
      const webhookResponse = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      console.log("Webhook Response received:", webhookResponse);

      // Process the MongoDB response
      let mongoResult;
      try {
        mongoResult = await mongoResponse.clone().json();
        console.log("✅ MongoDB JSON Response:", mongoResult);
      } catch (e) {
        const text = await mongoResponse.text();
        console.error("❌ Failed to parse JSON from MongoDB:", e);
        console.log("📄 Raw text response:", text);
      }


      // Process the webhook response
      let webhookResult;
      try {
        webhookResult = await webhookResponse.json();
        console.log("Response from webhook:", webhookResult);
      } catch (e) {
        console.error("Error parsing webhook response:", e);
        // If we can't parse JSON, check if the request was still successful
        if (webhookResponse.ok) {
          console.log("Webhook request was successful despite JSON parsing error");
        }
      }

      // Determine if the overall operation was successful
      const isSuccess = (mongoResponse.ok || mongoResult?.success) && webhookResponse.ok;

      if (isSuccess) {
        toast.success('Rebate successfully submitted!', {
          duration: 4000,
          icon: '✅'
        });
        setShowModal(false);
      } else {
        toast.error('Error submitting rebate', {
          description: 'Please check the console for details',
          duration: 5000
        });
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit rebate!");
    }
  };

  // Calculate totals for the summary
  const totalNoConnectionRebate = months.reduce((total, month) => total + month.noConnectionRebate, 0);
  const totalSlowConnectionRebate = months.reduce((total, month) => total + month.slowConnectionRebate, 0);

  // Add this state for editing
  const [editingMonth, setEditingMonth] = useState(null);

  // Add these functions for editing
  const startEditing = (month) => {
    setEditingMonth({ ...month });
  };

  // Save edited month with validation
  const saveEditedMonth = () => {
    if (editingMonth) {
      // Validate the editing form
      const errors = {};
      let isValid = true;

      if (!editingMonth.selectedCycle) {
        errors[`month_${editingMonth.id}_cycle`] = 'Billing cycle is required';
        isValid = false;
      }

      if (!editingMonth.startDate) {
        errors[`month_${editingMonth.id}_startDate`] = 'Start date is required';
        isValid = false;
      }

      if (!editingMonth.endDate) {
        errors[`month_${editingMonth.id}_endDate`] = 'End date is required';
        isValid = false;
      } else if (editingMonth.startDate && new Date(editingMonth.endDate) < new Date(editingMonth.startDate)) {
        errors[`month_${editingMonth.id}_endDate`] = 'End date must be after start date';
        isValid = false;
      }

      if (!editingMonth.planMSF) {
        errors[`month_${editingMonth.id}_planMSF`] = 'Plan MSF is required';
        isValid = false;
      }

      // If validation fails, update errors and return
      if (!isValid) {
        setFormErrors({ ...formErrors, ...errors });
        return;
      }

      // Calculate the values if we have both dates
      let updatedEditingMonth = editingMonth;
      if (editingMonth.startDate && editingMonth.endDate) {
        updatedEditingMonth = calculateValues({ ...editingMonth });
      }

      // Update the months array with the edited month
      const updatedMonths = months.map(month =>
        month.id === editingMonth.id ? updatedEditingMonth : month
      );

      setMonths(updatedMonths);
      setEditingMonth(null);
    }
  }
  const cancelEditing = () => {
    setEditingMonth(null);
  };

  const handleEditingMonthChange = (field, value) => {
    // Create the updated month object
    const updatedMonth = { ...editingMonth, [field]: value };

    // Update calculations if both dates are set
    let calculatedMonth = updatedMonth;
    if (updatedMonth.startDate && updatedMonth.endDate &&
      (field === "startDate" || field === "endDate" || field === "planMSF" || field === "selectedCycle")) {
      calculatedMonth = calculateValues(updatedMonth);
    }

    // Set the editing month state
    setEditingMonth(calculatedMonth);

    // Also update the month in the main table for real-time reflection
    const updatedMonths = months.map(month =>
      month.id === editingMonth.id ? calculatedMonth : month
    );
    setMonths(updatedMonths);
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      {/* Main Container */}
      <div className="flex-grow overflow-y-auto px-2 md:px-4 py-3">
        <div className={`bg-white bg-opacity-60 dark:bg-white dark:bg-opacity-10 rounded-lg p-4 h-full flex flex-col transition-all duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
          {currentPhase === 1 ? (
            /* Phase 1: Rebate Calculator Input */
            <div className="flex flex-col h-full">
              <h2 className={`text-2xl font-semibold dark:text-white pb-2 transition-all duration-500 delay-100 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>REBATE CALCULATOR</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 flex-grow overflow-hidden">
                {/* Left input form */}
                {editingMonth ? (
                  // Edit mode form
                  <div className={`space-y-4 bg-white dark:bg-laryzeDarkGray dark:bg-opacity-90 rounded-lg p-4 shadow-sm overflow-y-auto md:col-span-1 border-t-8 border-black dark:border-uasYellow transition-all duration-500 delay-200 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
                    <h3 className="font-medium dark:text-white">Edit Billing Period</h3>
                    <div>
                      <label className="block mb-2 text-sm font-medium text-black dark:text-white">Billing Cycle</label>
                      <select
                        className={`bg-white dark:bg-laryzeDarkGray dark:text-white border ${formErrors[`month_${editingMonth.id}_cycle`] ? 'border-red-500' : 'border-gray-300'} text-gray-900 dark:bg-white dark:bg-opacity-20 text-gray-900 dark:placeholder-gray-400 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5 transition-colors duration-200`}
                        value={editingMonth.selectedCycle.name}
                        onChange={(e) => {
                          const newCycle = billingCycles.find(cycle => cycle.name === e.target.value);
                          handleEditingMonthChange("selectedCycle", newCycle);
                        }}
                        required
                      >
                        {billingCycles.map((cycle, i) => (
                          <option
                            key={i}
                            value={cycle.name}
                            className="bg-white dark:bg-laryzeDarkGray dark:text-white text-gray-900"
                          >
                            {cycle.name}
                          </option>
                        ))}
                      </select>
                      {getErrorMessage(`month_${editingMonth.id}_cycle`)}
                    </div>
                    <div>
                      <label className="block mb-2 text-sm font-medium text-black dark:text-white">Start Date</label>
                      <input
                        type="date"
                        className={`bg-gray-50 dark:text-white dark:bg-white dark:bg-opacity-20 dark:border-laryzeDarkGray border ${formErrors[`month_${editingMonth.id}_startDate`] ? 'border-red-500' : 'border-gray-300'
                          } text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5`}
                        value={editingMonth.startDate}
                        onChange={(e) => handleEditingMonthChange("startDate", e.target.value)}
                        required
                      />
                      {getErrorMessage(`month_${editingMonth.id}_startDate`)}
                    </div>
                    <div>
                      <label className="block mb-2 text-sm font-medium text-black dark:text-white">End Date</label>
                      <input
                        type="date"
                        className={`bg-gray-50 dark:text-white dark:bg-white dark:bg-opacity-20 dark:border-laryzeDarkGray border ${formErrors[`month_${editingMonth.id}_endDate`] ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5`}
                        value={editingMonth.endDate}
                        onChange={(e) => handleEditingMonthChange("endDate", e.target.value)}
                        required
                      />
                      {getErrorMessage(`month_${editingMonth.id}_endDate`)}
                    </div>
                    <div>
                      <label className="block mb-2 text-sm font-medium text-black dark:text-white">Plan Monthly Service Fee</label>
                      <input
                        type="number"
                        className={`bg-gray-50 dark:text-white dark:bg-white dark:bg-opacity-20 dark:border-laryzeDarkGray border ${formErrors[`month_${editingMonth.id}_planMSF`] ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5`}
                        value={editingMonth.planMSF}
                        onChange={(e) => handleEditingMonthChange("planMSF", e.target.value)}
                        required
                      />
                      {getErrorMessage(`month_${editingMonth.id}_planMSF`)}
                    </div>
                    <div className="pt-2 flex justify-between">
                      <button
                        onClick={cancelEditing}
                        className="text-gray-700 bg-gray-200 hover:bg-gray-300 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={saveEditedMonth}
                        className="text-white bg-gray-900  hover:bg-yellow-800 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-black dark:bg-opacity-50"
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className={`bg-white dark:bg-laryzeDarkGray dark:bg-opacity-90 rounded-lg p-4 shadow-sm overflow-y-auto md:col-span-1 border-t-8 border-black dark:border-uasYellow transition-all duration-500 delay-200 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
                    <div className="space-y-4">
                      <h3 className="font-medium dark:text-white">Add Billing Period</h3>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-black dark:text-white">Billing Cycle</label>
                        <select
                          className={`bg-white dark:bg-laryzeDarkGray dark:text-white border ${formErrors['month_0_cycle'] ? 'border-red-500' : 'border-gray-300'
                            } text-gray-900 dark:bg-white dark:bg-opacity-20 text-gray-900 dark:placeholder-gray-400 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5 transition-colors duration-200`}
                          value={months[0].selectedCycle.name}
                          onChange={(e) =>
                            updateMonth(
                              months[0].id,
                              "selectedCycle",
                              billingCycles.find((cycle) => cycle.name === e.target.value)
                            )
                          }
                          required
                        >
                          {billingCycles.map((cycle, i) => (
                            <option
                              key={i}
                              value={cycle.name}
                              className="bg-white dark:bg-laryzeDarkGray dark:text-white text-gray-900"
                            >
                              {cycle.name}
                            </option>
                          ))}
                        </select>
                        {getErrorMessage('month_0_cycle')}
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-black dark:text-white">Start Date</label>
                        <input
                          type="date"
                          className={`bg-gray-50 dark:text-white dark:bg-white dark:bg-opacity-20 dark:border-laryzeDarkGray border ${formErrors['month_0_startDate'] ? 'border-red-500' : 'border-gray-300'
                            } text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5`}
                          value={months[0].startDate}
                          onChange={(e) => updateMonth(months[0].id, "startDate", e.target.value)}
                          required
                        />
                        {getErrorMessage('month_0_startDate')}
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-black dark:text-white">End Date</label>
                        <input
                          type="date"
                          className={`bg-gray-50 dark:text-white dark:bg-white dark:bg-opacity-20 dark:border-laryzeDarkGray border ${formErrors['month_0_endDate'] ? 'border-red-500' : 'border-gray-300'
                            } text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5`}
                          value={months[0].endDate}
                          onChange={(e) => updateMonth(months[0].id, "endDate", e.target.value)}
                          required
                        />
                        {getErrorMessage('month_0_endDate')}
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-black dark:text-white">Plan Monthly Service Fee</label>
                        <input
                          type="number"
                          className={`bg-gray-50 dark:text-white dark:bg-white dark:bg-opacity-20 dark:border-laryzeDarkGray border ${formErrors['month_0_planMSF'] ? 'border-red-500' : 'border-gray-300'
                            } text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5`}
                          value={months[0].planMSF}
                          onChange={(e) => updateMonth(months[0].id, "planMSF", e.target.value)}
                          required
                        />
                        {getErrorMessage('month_0_planMSF')}
                      </div>
                      <div className="pt-2 flex justify-center">
                        <button
                          onClick={addMonth}
                          className="text-white bg-gray-900 hover:bg-uasYellow hover:text-black transition  focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-black dark:bg-opacity-50"
                        >
                          Add Month
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {/* Right billing cycle display */}
                <div className={`bg-white dark:bg-laryzeDarkGray dark:bg-opacity-90 rounded-lg shadow-sm flex flex-col h-full md:col-span-2 border-t-8 border-black dark:border-uasYellow transition-all duration-500 delay-300 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
                  <div className="bg-gray-50 dark:bg-transparent p-3 rounded-t-lg border-b border-gray-200">
                    <div className="grid grid-cols-4">
                      <div className="text-sm font-medium text-gray-700 dark:text-white">Billing Cycle</div>
                      <div className="text-sm font-medium text-gray-700 dark:text-white">Start Date</div>
                      <div className="text-sm font-medium text-gray-700 dark:text-white">End Date</div>
                      <div className="text-sm font-medium text-gray-700 dark:text-white">Plan Monthly Service Fee</div>
                    </div>
                  </div>
                  <div className="overflow-y-auto flex-grow dark:text-white">
                    {renderMonthsTable()}
                  </div>
                </div>
              </div>
              {/* Navigation Buttons */}
              <div className={`flex justify-end gap-3 mt-2 pt-2 transition-all duration-500 delay-500 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
                <button
                  onClick={clearMonths}
                  className="text-gray-900 bg-gray-200 hover:bg-gray-300 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5"
                >
                  Clear all
                </button>
                <button
                  onClick={handleNextPhase}
                  disabled={!isFormValid || months.length === 0}
                  className={`text-white ${!isFormValid || months.length === 0
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-laryzeDarkGray dark:bg-uasYellow dark:text-black dark:md:hover:bg-yellow-300 hover:bg-yellow-800'
                    } focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5`}
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            /* Phase 2: Rebate Summary */
            <div className="flex flex-col h-full overflow-hidden">
              {/* Title */}
              <h2
                className={`text-2xl font-semibold text-gray-800 pb-2 dark:text-white transition-all duration-500 delay-100 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                  }`}
              >
                REBATE SUMMARY
              </h2>

              {/* Summary Table */}
              <div
                className={`overflow-x-auto dark:bg-laryzeDarkGray dark:bg-opacity-90 rounded-lg border border-gray-200 border-t-[8px] dark:border-transparent border-t-black dark:border-t-uasYellow transition-all duration-500 delay-200 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                  }`}
              >
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <thead className="bg-gray-50 dark:bg-transparent">
                    <tr>
                      {[
                        "Plan MSF",
                        "Cycle Days",
                        "Days Reported",
                        "No Connection",
                        "Computation (No Connection)",
                        "Slow Connection",
                        "Computation (Slow / Intermittent)",
                      ].map((header) => (
                        <th
                          key={header}
                          className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap dark:text-white"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 text-xs dark:bg-transparent dark:divide-gray-600 dark:text-white">
                    {months.map((month, index) => (
                      <tr
                        key={month.id}
                        className={`hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                          }`}
                        style={{ transitionDelay: `${300 + index * 50}ms` }}
                      >
                        <td className="px-3 py-2 whitespace-nowrap">{month.planMSF}</td>
                        <td className="px-3 py-2 whitespace-nowrap">{month.cycleDays}</td>
                        <td className="px-3 py-2 whitespace-nowrap">{month.daysReported}</td>
                        <td className="px-3 py-2 whitespace-nowrap">
                          {month.noConnectionRebate.toFixed(2)}
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap">{month.formulaNoConnection}</td>
                        <td className="px-3 py-2 whitespace-nowrap">
                          {month.slowConnectionRebate.toFixed(2)}
                        </td>
                        <td className="px-3 py-2 whitespace-nowrap">{month.formulaSlowConnection}</td>
                      </tr>
                    ))}
                    <tr
                      className={`bg-gray-50 font-semibold text-xs dark:bg-transparent dark:divide-gray-600 transition-all duration-500 delay-500 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                        }`}
                    >
                      <td colSpan={3} className="px-3 py-2 text-right">
                        Total:
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap">
                        {totalNoConnectionRebate.toFixed(2)}
                      </td>
                      <td className="px-3 py-2"></td>
                      <td className="px-3 py-2 whitespace-nowrap">
                        {totalSlowConnectionRebate.toFixed(2)}
                      </td>
                      <td className="px-3 py-2"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Form Card */}
              <div
                className={`bg-white dark:bg-laryzeDarkGray dark:bg-opacity-90 mt-2 px-4 pb-2 rounded-lg border-t-8 border-black dark:border-t-uasYellow transition-all duration-500 delay-400 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                  }`}
              >
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                  {/* Rebate Ticket Number */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
                      Rebate Ticket Number
                    </label>
                    <input
                      type="text"
                      name="ticketNumber"
                      placeholder="e.g., SF-12345"
                      className="bg-gray-50 dark:bg-white dark:bg-opacity-20 dark:border-bg-white dark:border-opacity-50 dark:text-white dark:placeholder-gray-300 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5"
                      value={customerInfo.ticketNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        let warning = "";

                        if (value && !value.startsWith("SF-")) {
                          warning = "Ticket number must start with 'SF-'.";
                        } else if (/\s/.test(value)) {
                          warning = "Spaces are not allowed.";
                        } else if (value && !/^SF-[^\s]*$/.test(value)) {
                          warning = "Invalid format. Use SF- followed by numbers/letters.";
                        }

                        setCustomerInfo({
                          ...customerInfo,
                          ticketNumber: value,
                          ticketNumberWarning: warning,
                        });
                      }}
                    />
                    {customerInfo.ticketNumberWarning && (
                      <p className="mt-1 text-sm text-red-500">
                        {customerInfo.ticketNumberWarning}
                      </p>
                    )}
                  </div>

                  {/* Restoration Date */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
                      Restoration Date
                    </label>
                    <input
                      type="date"
                      name="restorationDate"
                      className="bg-gray-50 dark:bg-white dark:bg-opacity-20 dark:border-bg-white dark:border-opacity-50 dark:text-white dark:placeholder-gray-300 resize-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5"
                      value={customerInfo.restorationDate}
                      onChange={handleCustomerChange}
                    />
                  </div>

                  {/* Reasons for Rebate */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
                      Reasons for Rebate
                    </label>
                    <select
                      name="rebateReason"
                      className="bg-white dark:text-white border border-gray-300 dark:border-gray-600 dark:bg-opacity-20 p-3 text-gray-900 dark:text-white text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5 transition-colors duration-200"
                      value={customerInfo.rebateReason}
                      onChange={handleCustomerChange}
                      required
                    >
                      <option value="" disabled className="bg-white dark:bg-laryzeDarkGray dark:text-white">
                        Select Reason
                      </option>
                      <option value="NO INTERNET CONNECTION" className="bg-white dark:bg-laryzeDarkGray dark:text-white">
                        NO INTERNET CONNECTION
                      </option>
                      <option value="SLOW INTERNET CONNECTION" className="bg-white dark:bg-laryzeDarkGray dark:text-white">
                        SLOW INTERNET CONNECTION
                      </option>
                    </select>
                  </div>
                </div>

                {/* Details */}
                <div
                  className={`grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 transition-all duration-500 delay-500 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                    }`}
                >
                  {[
                    {
                      name: "requestDetails",
                      label: "Details of the Request",
                      placeholder: "Enter details of the request...",
                    },
                    {
                      name: "rfo",
                      label: "RFO (Root Cause / Fault Origin)",
                      placeholder:
                        "The complete RFO should be indicated, not just the case numbers...",
                    },
                    {
                      name: "resolution",
                      label: "Resolution",
                      placeholder: "e.g., Validated and forwarded to the Approver",
                    },
                    {
                      name: "expectation",
                      label: "Customer's expectations",
                      placeholder:
                        "e.g., The rebate request will be reflected in the next billing",
                    },
                  ].map((field) => (
                    <div key={field.name}>
                      <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
                        {field.label}
                      </label>
                      <textarea
                        name={field.name}
                        rows="3"
                        placeholder={field.placeholder}
                        className="bg-gray-50 dark:bg-white dark:bg-opacity-20 dark:border-bg-white dark:border-opacity-50 dark:text-white dark:placeholder-gray-300 resize-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5"
                        value={customerInfo[field.name]}
                        onChange={handleCustomerChange}
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation Buttons */}
              <div
                className={`flex justify-end gap-3 mt-2 transition-all duration-500 delay-600 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                  }`}
              >
                <button
                  onClick={handlePreviousPhase}
                  className="text-gray-900 bg-gray-200 hover:bg-gray-300 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5"
                >
                  Back
                </button>
                {(() => {
                  const ticketInvalid =
                    !customerInfo.ticketNumber ||
                    !!customerInfo.ticketNumberWarning ||
                    !/^SF-[^\s]*$/.test(customerInfo.ticketNumber);

                  return (
                    <button
                      onClick={handleSubmit}
                      disabled={ticketInvalid}
                      className={`font-medium rounded-lg text-sm px-5 py-2.5 ${ticketInvalid
                          ? "bg-gray-400 text-white cursor-not-allowed"
                          : "text-white bg-laryzeDarkGray dark:bg-uasYellow dark:text-black dark:md:hover:bg-yellow-300 hover:bg-uasYellow hover:text-black focus:ring-4 focus:ring-yellow-300"
                        }`}
                    >
                      Submit
                    </button>
                  );
                })()}
              </div>
            </div>

          )}
          {/* Modal for submission confirmation */}
          {showModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 dark:bg-black dark:bg-opacity-70 overflow-y-auto flex items-center justify-center z-50">
              <div className={`relative bg-white dark:bg-laryzeDarkGray dark:bg-opacity-90 rounded-lg shadow-xl p-6 max-w-4xl max-h-screen overflow-y-auto m-4 transition-all duration-300 ${isLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
                {/* Close Button */}
                <button
                  className="absolute top-3 right-3 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
                  onClick={() => setShowModal(false)}
                >
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                <h2 className="text-xl font-bold mb-6 pr-8 dark:text-white">Rebate Summary Confirmation</h2>
                {/* Rebate Calculator Section */}
                <div className="mb-6">
                  <h3 className="text-lg font-semibold mb-3 border-b dark:border-gray-700 pb-2 dark:text-white">Rebate Calculator</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {months.map((month, index) => (
                      <div
                        key={month.id}
                        className={`p-4 bg-gray-50 dark:bg-gray-800 dark:bg-opacity-40 rounded-lg dark:text-gray-200 transition-all duration-300`}
                        style={{ transitionDelay: `${index * 100}ms` }}
                      >
                        <p><strong>Billing Cycle:</strong> {month.selectedCycle.name}</p>
                        <p><strong>Start Date:</strong> {month.startDate ? dayjs(month.startDate).format('MMM D, YYYY') : 'Not set'}</p>
                        <p><strong>End Date:</strong> {month.endDate ? dayjs(month.endDate).format('MMM D, YYYY') : 'Not set'}</p>
                        <p><strong>Plan MSF:</strong> {month.planMSF}</p>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Rebate Summary Table */}
                <div className="mb-6">
                  <h3 className="text-base font-semibold mb-2 border-b border-gray-300 dark:border-gray-700 pb-1 text-gray-800 dark:text-white">
                    Rebate Summary
                  </h3>
                  <div className="overflow-x-auto rounded-md shadow-sm border border-gray-200 dark:border-gray-700">
                    <table className="w-full text-xs text-left text-gray-700 dark:text-gray-300">
                      <thead className="bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 uppercase tracking-wide">
                        <tr>
                          <th className="px-3 py-2">Plan MSF</th>
                          <th className="px-3 py-2">Cycle Days</th>
                          <th className="px-3 py-2">Days Reported</th>
                          <th className="px-3 py-2">No Connection</th>
                          <th className="px-3 py-2">Computation (No Conn.)</th>
                          <th className="px-3 py-2">Slow Conn.</th>
                          <th className="px-3 py-2">Computation (Slow)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {months.map((month, index) => (
                          <tr
                            key={month.id}
                            className="bg-white dark:bg-gray-700 dark:bg-opacity-50 border-b dark:border-gray-600 dark:text-white transition-all duration-300"
                            style={{ transitionDelay: `${index * 50}ms` }}
                          >
                            <td className="px-3 py-1">{month.planMSF}</td>
                            <td className="px-3 py-1">{month.cycleDays}</td>
                            <td className="px-3 py-1">{month.daysReported}</td>
                            <td className="px-3 py-1">{month.noConnectionRebate.toFixed(2)}</td>
                            <td className="px-3 py-1">{month.formulaNoConnection}</td>
                            <td className="px-3 py-1">{month.slowConnectionRebate.toFixed(2)}</td>
                            <td className="px-3 py-1">{month.formulaSlowConnection}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* CARE Format Section */}
                <div className="mb-6">
                  <h3 className="text-lg font-semibold mb-3 border-b dark:border-gray-700 pb-2 dark:text-white">CARE Format</h3>
                  <div className="bg-gray-50 dark:bg-gray-800 dark:bg-opacity-40 p-4 rounded-lg dark:text-gray-200">
                    <div className="mb-4">
                      <h4 className="font-medium mb-2 dark:text-white">C - Concern/Complaint</h4>
                      <p className="text-sm pl-4">{customerInfo.rebateReason || "Not specified"}</p>
                    </div>
                    <div className="mb-4">
                      <h4 className="font-medium mb-2 dark:text-white">A - Action Taken and justification for the adjustment</h4>
                      <ul className="text-sm pl-8 list-disc space-y-1">
                        <li><span className="font-medium dark:text-gray-300">Details of the request:</span> {customerInfo.requestDetails || "Not provided"}</li>
                        <li><span className="font-medium dark:text-gray-300">Reference Ticket Number (if any):</span> {customerInfo.ticketNumber || "Not provided"}</li>
                        <li><span className="font-medium dark:text-gray-300">Issue Start Date:</span> {getDateRange().firstStartDate ? dayjs(getDateRange().firstStartDate).format('MMM D, YYYY') : "Not set"}</li>
                        <li><span className="font-medium dark:text-gray-300">Issue End Date:</span> {getDateRange().lastEndDate ? dayjs(getDateRange().lastEndDate).format('MMM D, YYYY') : "Not set"}</li>
                        <li><span className="font-medium dark:text-gray-300">Restoration Date:</span> {customerInfo.restorationDate ? dayjs(customerInfo.restorationDate).format('MMM D, YYYY') : "Not provided"}</li>
                        <li><span className="font-medium dark:text-gray-300">Bill Run:</span> {months[0]?.selectedCycle?.name || "Not set"}</li>
                        <li><span className="font-medium dark:text-gray-300">Plan:</span> {months[0]?.planMSF || "Not set"}</li>
                        <li>
                          <span className="font-medium dark:text-gray-300">Requested Dates:</span> {
                            months.map(m => m.startDate && m.endDate ?
                              `${dayjs(m.startDate).format('MMM D')} - ${dayjs(m.endDate).format('MMM D, YYYY')}` : ''
                            ).filter(Boolean).join(', ') || "Not set"
                          }
                        </li>
                        <li><span className="font-medium dark:text-gray-300">Number of Days Requested:</span> {months.reduce((total, m) => total + (m.daysReported || 0), 0) || "0"}</li>
                        <li>
                          <span className="font-medium dark:text-gray-300">Formula:</span>&nbsp;
                          {
                            customerInfo.rebateReason === "NO INTERNET CONNECTION"
                              ? months.map(m => m.formulaNoConnection).filter(Boolean).join(', ')
                              : months.map(m => m.formulaSlowConnection).filter(Boolean).join(', ')
                          }
                        </li>

                        <li>
                          <span className="font-medium dark:text-gray-300">Estimated Rebate Amount:</span> {
                            customerInfo.rebateReason === "NO INTERNET CONNECTION"
                              ? months.reduce((total, m) => total + (m.noConnectionRebate || 0), 0).toFixed(2)
                              : months.reduce((total, m) => total + (m.slowConnectionRebate || 0), 0).toFixed(2)
                          }
                        </li>
                        <li><span className="font-medium dark:text-gray-300">RFO:</span> {customerInfo.rfo || "Not provided"}</li>
                      </ul>
                    </div>
                    <div className="mb-4">
                      <h4 className="font-medium mb-2 dark:text-white">R - Resolution</h4>
                      <p className="text-sm pl-4">{customerInfo.resolution || "Not provided"}</p>
                    </div>
                    <div className="mb-4">
                      <h4 className="font-medium mb-2 dark:text-white">E - Expectation</h4>
                      <p className="text-sm pl-4">{customerInfo.expectation || "Not provided"}</p>
                    </div>
                  </div>
                </div>
                {/* Additional Notes */}
                <div className="mb-6">
                  <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-white">Trouble(Technical) Ticket Number:</label>
                  <textarea
                    name="notes"
                    className="bg-gray-50 dark:bg-white dark:bg-opacity-40 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5"
                    value={customerInfo.notes}
                    onChange={handleCustomerChange}
                    placeholder="Enter any additional information here..."
                    rows="4"
                  ></textarea>
                </div>
                {/* Submit Button */}
                <div className="flex justify-end">
                  <button
                    onClick={handleSubmitToMongoDB}
                    className="text-white bg-black transition dark:bg-uasYellow dark:text-black hover:bg-uasYellow hover:text-black dark:hover:bg-yellow-300 focus:ring-4 focus:ring-yellow-300 dark:focus:ring-yellow-500 font-medium rounded-lg text-sm px-5 py-2.5"
                  >
                    Send Approval
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

};
export default RebateCalculator;